<h2 class="pb-[2.5rem]">{{ 'video.title' | transloco }}</h2>
<div
  class="flex flex-col md:flex-row w-full divide-y-2 md:divide-y-0 divide-x-0 md:divide-x-2 divide-vinciBlue-300 rounded-xl bg-white mb-[2.5rem]"
>
  <app-filter-result-section
    [title]="'video.sector' | transloco"
    [filter]="videoStore.branchesFiltersSelected()"
    [filterExists]="videoStore.branchesFilterExists()"
    [textIfNoFilter]="'video.noSectorFilterSelected' | transloco"
  ></app-filter-result-section>
  @if (videoStore.activitiesFiltersSelected() !== null) {
    <app-filter-result-section
      [title]="'video.activity' | transloco"
      [filter]="videoStore.activitiesFiltersSelected()"
      [filterExists]="videoStore.activitiesFilterExists()"
      [textIfNoFilter]="'video.noActivityFilterSelected' | transloco"
    ></app-filter-result-section>
  }
</div>
<h2 class="mb-[1.5rem]">{{ 'video.results' | transloco }}</h2>

@if(loading()) {
<div class="my-[6.25rem]"><loader /></div>
} @else { @if (videoStore.anyResults()) {
<p class="!font-bold mb-[2.5rem]">
  {{ this.totalVideosFound() }} {{ this.totalVideosFound() > 1 ?
  ('video.foundManyResults' | transloco) : ('video.foundOneResult' | transloco)
  }}
</p>
<app-language-filter
  [availableLanguages]="availableLanguages()"
  [textToDisplayIfAnySelected]="'video.manyVideosAudioLanguages' | transloco"
  (updateResults)="onLanguagesChanged($event)"
></app-language-filter>

<div class="grid grid-cols-1 sm:grid-cols-2 gap-6 pb-6 mt-10">
  @for (video of shownVideos(); track $index) {
  <app-card-result
    [id]="video.id"
    [title]="video.title"
    [text]="video.text"
    [image]="video.base64Image"
    [link]="video.link"
    [variant]="$index % 4 === 0 ? 'primary' : $index % 4 === 1 ? 'secondary' : $index % 4 === 2 ? 'tertiary' : 'quaternary'"
    [isRedirectionExternal]="true"
    [isAbleToAddToFavorites]="true"
    [modalTextDisclaimer]="video.textDisclaimer"
  ></app-card-result>
  }
</div>
} @else {
<p class="text-center">{{ 'video.noVideoFound' | transloco }}</p>
} } @if(extraResultLoading()) {
<div class="my-[6.25rem]"><loader /></div>
}

<div class="flex flex-col sm:flex-row justify-end gap-6 pb-[2.5rem]">
  @if (videoStore.pagination() !== null && videoStore.pagination().total >
  videoStore.results().length) {
  <app-button
    [text]="'video.seeMoreJobs' | transloco"
    [variant]="'primary'"
    [disabled]="extraResultLoading()"
    (buttonClick)="loadMoreVideoTiles()"
  ></app-button>
  }
  <app-button
    [text]="'video.resetResearch' | transloco"
    [variant]="'secondary'"
    [icon]="'back'"
    [iconSize]="'1.5rem'"
    [size]="'sm'"
    [disabled]="extraResultLoading()"
    (buttonClick)="redirectToVideoResearch()"
  ></app-button>
</div>

<app-favorite-tile-error-modal />
